export interface ProductBanner {
  label: string
  variant: 'new' | 'bestseller'
}

const BANNER_BY_TAG: Record<string, ProductBanner> = {
  'new product': { label: 'New Product', variant: 'new' },
  'best seller': { label: 'Best Seller', variant: 'bestseller' },
}

export function resolveProductBanner(productTag?: string | null): ProductBanner | null {
  if (!productTag)
    return null

  for (const raw of productTag.split(',')) {
    const banner = BANNER_BY_TAG[raw.trim().toLowerCase()]
    if (banner)
      return banner
  }

  return null
}
